exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".Masthead-9a96cd6f{margin-top:70px;margin-bottom:60px;color:#333;text-align:center}@media screen and (max-width: 800px){.Masthead-9a96cd6f{margin-top:35px;margin-bottom:30px}}\n", ""]);

// Exports
exports.locals = {
	"Masthead": "Masthead-9a96cd6f"
};